/* =============================================================
   iLUMINAIRE — Master JavaScript
   Vanilla JS only. No frameworks.
   ============================================================= */

(function () {
  'use strict';

  /* ============ HERO RAYS ============ */
  function initRays() {
    const container = document.querySelector('.rays');
    if (!container) return;
    const count = 18;
    for (let i = 0; i < count; i++) {
      const ray = document.createElement('div');
      ray.className = 'ray';
      ray.style.left = Math.random() * 100 + '%';
      ray.style.height = (80 + Math.random() * 120) + 'px';
      ray.style.animationDuration = (6 + Math.random() * 10) + 's';
      ray.style.animationDelay = (-Math.random() * 14) + 's';
      container.appendChild(ray);
    }
  }

  /* ============ FESTIVE MODE ============ */
  // Liquid set html.is-festive if today is in the window, but a cached page can
  // outlive that — so re-check today's UK date here. Then: hero snowfall, light
  // snow over every page, fairy lights under the nav and the opt-in music button.
  function initFestive() {
    var root = document.documentElement;
    if (!root.classList.contains('is-festive')) return;
    // yearly window as MMDD numbers; it may wrap New Year (1026 -> 101)
    var today = 0;
    try {
      today = +new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' })
        .format(new Date()).slice(5).replace('-', '');
    } catch (e) {}
    var start = +root.dataset.festiveStart, end = +root.dataset.festiveEnd;
    var inside = start <= end ? (today >= start && today <= end) : (today >= start || today <= end);
    if (today && start && end && !inside) { root.classList.remove('is-festive'); return; }

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.innerWidth <= 720;

    // depth 0 = far, 1 = near; `slow` stretches the fall for the page-wide layer
    function addFlakes(box, count, maxOpacity, slow) {
      for (var i = 0; i < count; i++) {
        var flake = document.createElement('div');
        var inner = document.createElement('i');
        var depth = Math.random();
        flake.className = 'flake' + (Math.random() < 0.15 ? ' gold' : '');
        flake.style.left = (Math.random() * 100) + '%';
        flake.style.opacity = ((0.3 + depth * 0.7) * maxOpacity).toFixed(2);
        if (depth > 0.8) flake.style.filter = 'blur(1px)';
        flake.style.animationDuration = ((16 - depth * 8 + Math.random() * 4) * slow) + 's';
        flake.style.animationDelay = (-Math.random() * 20 * slow) + 's';
        inner.style.setProperty('--sway', (8 + Math.random() * 22) + 'px');
        inner.style.animationDuration = (2.5 + Math.random() * 3) + 's';
        if (Math.random() < 0.3) {
          inner.textContent = '❄︎';
          inner.style.fontSize = (9 + depth * 9) + 'px';
        } else {
          inner.className = 'dot';
          inner.style.setProperty('--s', (2 + depth * 3.5).toFixed(1) + 'px');
        }
        if (still) flake.style.top = (Math.random() * 100) + '%';
        flake.appendChild(inner);
        box.appendChild(flake);
      }
    }

    var snow = document.querySelector('.snow');
    if (snow) addFlakes(snow, mobile ? 22 : 42, 0.8, 1);
    var pageSnow = document.querySelector('.festive-snow');
    if (pageSnow) addFlakes(pageSnow, mobile ? 9 : 16, 0.5, 1.6);

    // Hero snow pauses once the hero has faded; on the homepage the page-wide
    // layer waits until then so the two don't double up.
    var isHome = document.body.classList.contains('template-index');
    function onScroll() {
      var pastHero = window.scrollY >= window.innerHeight * 0.85;
      if (snow) snow.classList.toggle('paused', window.scrollY >= window.innerHeight);
      if (pageSnow && isHome) pageSnow.classList.toggle('off', !pastHero);
      // the hero has its own music box, so the corner button waits for it to go
      if (floatMusic && isHome) floatMusic.classList.toggle('fm-away', !pastHero);
    }
    var floatMusic = document.querySelector('.festive-music');
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    initFairyLights(still);
    initFestiveMusic();
  }

  // A swagged wire across the bottom of the nav, three bulbs per swag.
  function initFairyLights(still) {
    var box = document.querySelector('.festive-lights');
    if (!box) return;
    var COLOURS = [
      ['#ffe1ad', 'rgba(255,196,110,0.45)'],   // warm white — most of them
      ['#ffe1ad', 'rgba(255,196,110,0.45)'],
      ['#ffe1ad', 'rgba(255,196,110,0.45)'],
      ['#f2c46b', 'rgba(242,196,107,0.45)'],   // gold
      ['#a8e6ff', 'rgba(91,200,245,0.5)']      // ice blue (brand accent)
    ];
    function draw() {
      var w = box.clientWidth;
      if (!w) return;
      var n = Math.max(2, Math.round(w / (window.innerWidth <= 720 ? 110 : 170)));
      var P = w / n, sag = 9, top = 1;
      var d = 'M0 ' + top, bulbs = '';
      for (var i = 0; i < n; i++) {
        var x0 = i * P;
        d += ' Q' + (x0 + P / 2).toFixed(1) + ' ' + (top + 2 * sag) + ' ' + (x0 + P).toFixed(1) + ' ' + top;
        [1 / 6, 1 / 2, 5 / 6].forEach(function (t) {
          var c = COLOURS[Math.floor(Math.random() * COLOURS.length)];
          var y = top + 4 * sag * t * (1 - t);
          bulbs += '<span class="fl-bulb" style="left:' + (x0 + t * P).toFixed(1) + 'px;top:' + y.toFixed(1) +
            'px;--c:' + c[0] + ';--g:' + c[1] + ';transform:rotate(' + ((Math.random() - 0.5) * 16).toFixed(1) +
            'deg);animation-duration:' + (1.6 + Math.random() * 2.6).toFixed(2) + 's;animation-delay:' +
            (-Math.random() * 4).toFixed(2) + 's' + (still ? ';animation:none' : '') + '"></span>';
        });
      }
      box.innerHTML = '<svg viewBox="0 0 ' + w + ' 26" preserveAspectRatio="none"><path d="' + d +
        '" fill="none" stroke="rgba(201,162,90,0.45)" stroke-width="1"/></svg>' + bulbs;
    }
    draw();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(draw, 150); });
  }

  // Festive music: a cosy jazz-waltz "We Wish You a Merry Christmas" (traditional,
  // public domain) — Rhodes comping, upright bass, sleigh bells and vibraphone,
  // synthesised with Web Audio, so there's no audio file or licence. Browsers
  // block sound until the visitor interacts, so it starts on their first
  // tap/click/key anywhere — unless they've muted it, which is remembered.
  // Every [data-festive-music] control (hero box + corner button) shows a gold
  // wave that follows the music while it plays and lies flat when it's off.
  function initFestiveMusic() {
    var controls = [].slice.call(document.querySelectorAll('[data-festive-music]'));
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!controls.length) return;
    if (!AC) { controls.forEach(function (c) { c.remove(); }); return; }
    var KEY = 'iluminaire_festive_music';          // '0' = visitor muted it
    var AUTOSTART = document.documentElement.dataset.festiveAutostart !== '0';
    // ---- Arrangement: 3/4 jazz waltz in G, swung eighths. Times are in beats. ----
    var BEAT = 60 / 168, SWING = 0.62;           // the "and" lands late — the lilt
    function sw(at) { var f = at % 1; return f ? Math.floor(at) + (f === 0.5 ? SWING : f) : at; }
    // melody of one verse: [beat, midi, beats long]; beat 0 is the pick-up ("We")
    var VERSE = [
      [0,62,1],
      [1,67,1],[2,67,.5],[2.5,69,.5],[3,67,.5],[3.5,66,.5],
      [4,64,1],[5,64,1],[6,64,1],
      [7,69,1],[8,69,.5],[8.5,71,.5],[9,69,.5],[9.5,67,.5],
      [10,66,1],[11,62,1],[12,62,1],
      [13,71,1],[14,71,.5],[14.5,72,.5],[15,71,.5],[15.5,69,.5],
      [16,67,1],[17,64,1],[18,62,.5],[18.5,62,.5],
      [19,64,1],[20,69,1],[21,66,1],
      [22,67,2]
    ];
    // chords: [beat, bass root, bass fifth, Rhodes voicing]
    var G = [43, 50, [59,62,66]], C = [48, 43, [57,60,64]], A7 = [45, 40, [61,64,67]],
        D7 = [50, 45, [60,64,66]], B7 = [47, 42, [57,63,66]], Em = [40, 47, [55,59,62]];
    var CHORDS = [[1,G],[4,C],[7,A7],[10,D7],[13,B7],[16,Em],[19,C,'first'],[21,D7,'change'],[22,G]];  // bar 7 splits C | D7
    var VLEN = 24, LOOP = VLEN * 2 + 3;          // two verses + a one-bar tag
    var events = [];
    function add(at, fn, m, v, d) { events.push({ at: sw(at), fn: fn, m: m, v: v, d: d }); }
    for (var vs = 0; vs < 2; vs++) {
      var o = vs * VLEN;
      VERSE.forEach(function (n) {
        add(o + n[0], 'vibes', n[1] + 12, 0.42, n[2]);
        if (vs) add(o + n[0], 'bell', n[1] + 24, 0.07, n[2]);   // sparkle on the repeat
      });
      add(o, 'rhodes', D7[2], 0.11, 0.5);                       // pick-up
      add(o, 'bass', D7[0], 0.5, 1);
      CHORDS.forEach(function (c) {
        var at = o + c[0], ch = c[1];
        if (c[2] === 'change') { add(at, 'bass', ch[0], 0.45, 1); add(at, 'rhodes', ch[2], 0.12, 0.6); return; }
        if (c[2] === 'first') { add(at, 'bass', ch[0], 0.5, 1.6); add(at + 1, 'rhodes', ch[2], 0.12, 0.5); return; }
        add(at, 'bass', ch[0], 0.5, 1.6);
        add(at + 2, 'bass', ch[1], 0.38, 0.9);
        add(at + 1, 'rhodes', ch[2], 0.12, 0.5);
        add(at + 2, 'rhodes', ch[2], 0.1, 0.35);
        if (c[0] === 22) add(at + 1.5, 'rhodes', ch[2], 0.08, 0.3);
      });
    }
    // tag: rolled G6/9 on the bells, Rhodes + bass ring out
    add(48, 'bass', 43, 0.5, 2.5);
    add(48, 'rhodes', [57,59,64,66], 0.11, 2.5);
    [67,71,74,76,79].forEach(function (m, i) { add(48 + i * 0.5, 'bell', m + 12, 0.08, 1); });
    for (var bt = 0; bt < LOOP; bt++) {                          // sleigh bells throughout
      add(bt, 'jingle', 0, bt % 3 ? 0.07 : 0.12, 0);
      if (bt % 3 === 2) add(bt + 0.5, 'jingle', 0, 0.05, 0);
    }
    events.sort(function (a, b) { return a.at - b.at; });

    var ctx, bus, master, analyser, wave, noise, timer, loopStart, ei = 0, playing = false;
    function build() {
      ctx = new AC();
      bus = ctx.createGain();
      master = ctx.createGain();
      master.gain.value = 0.0001;
      analyser = ctx.createAnalyser();
      analyser.fftSize = 1024;
      wave = new Float32Array(analyser.fftSize);
      var tone = ctx.createBiquadFilter();
      tone.type = 'lowpass'; tone.frequency.value = 9000;
      var verb = ctx.createConvolver(), wet = ctx.createGain();
      var len = Math.floor(ctx.sampleRate * 2.2), ir = ctx.createBuffer(2, len, ctx.sampleRate);
      for (var ch = 0; ch < 2; ch++) {
        var data = ir.getChannelData(ch);
        for (var i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3.5);
      }
      verb.buffer = ir; wet.gain.value = 0.28;
      noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      var nd = noise.getChannelData(0);
      for (var k = 0; k < nd.length; k++) nd[k] = Math.random() * 2 - 1;
      bus.connect(analyser);                       // level for the wave, before the volume
      bus.connect(master);
      master.connect(tone);
      tone.connect(ctx.destination);
      tone.connect(verb); verb.connect(wet); wet.connect(ctx.destination);
      ctx.onstatechange = render;
    }
    function hz(m) { return 440 * Math.pow(2, (m - 69) / 12); }
    function env(g, t, v, attack, end) {
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(v, t + attack);
      g.gain.exponentialRampToValueAtTime(0.0001, end);
    }
    var VOICES = {
      // vibraphone: soft fundamental + 4th partial, motor tremolo
      vibes: function (m, t, v, d) {
        var f = hz(m), out = ctx.createGain(), trem = ctx.createGain(), lfo = ctx.createOscillator(), depth = ctx.createGain();
        var end = t + Math.max(d * BEAT, 0.3) + 1.6;
        lfo.frequency.value = 5.2; depth.gain.value = 0.22; trem.gain.value = 0.8;
        lfo.connect(depth); depth.connect(trem.gain);
        [[1, 1, end], [4, 0.12, t + 0.35], [10.2, 0.025, t + 0.08]].forEach(function (p) {
          var o = ctx.createOscillator(), g = ctx.createGain();
          o.frequency.value = f * p[0];
          env(g, t, v * p[1], 0.004, p[2]);
          o.connect(g); g.connect(trem); o.start(t); o.stop(p[2] + 0.05);
        });
        trem.connect(out); out.connect(bus);
        lfo.start(t); lfo.stop(end + 0.05);
      },
      // little bell/celesta for sparkle
      bell: function (m, t, v) {
        var f = hz(m);
        [[1, 1, 1.4], [3, 0.2, 0.25]].forEach(function (p) {
          var o = ctx.createOscillator(), g = ctx.createGain();
          o.frequency.value = f * p[0];
          env(g, t, v * p[1], 0.003, t + p[2]);
          o.connect(g); g.connect(bus); o.start(t); o.stop(t + p[2] + 0.05);
        });
      },
      // Rhodes electric piano: FM bell-tone per chord note, warm low-pass
      rhodes: function (notes, t, v, d) {
        var lp = ctx.createBiquadFilter();
        lp.type = 'lowpass'; lp.frequency.value = 2600; lp.connect(bus);
        var end = t + d * BEAT + 0.55;
        notes.forEach(function (m, i) {
          var f = hz(m), tt = t + i * 0.012;                     // a hint of a roll
          var car = ctx.createOscillator(), mod = ctx.createOscillator(), mg = ctx.createGain(), g = ctx.createGain();
          car.frequency.value = f; mod.frequency.value = f;
          mg.gain.setValueAtTime(f * 1.6, tt);
          mg.gain.exponentialRampToValueAtTime(f * 0.12, tt + 0.5);
          mod.connect(mg); mg.connect(car.frequency);
          env(g, tt, v, 0.005, end);
          car.connect(g); g.connect(lp);
          car.start(tt); mod.start(tt); car.stop(end + 0.05); mod.stop(end + 0.05);
        });
      },
      // upright bass: round triangle + sine through a low-pass, plucked decay
      bass: function (m, t, v, d) {
        var f = hz(m), lp = ctx.createBiquadFilter(), g = ctx.createGain();
        var end = t + Math.max(d * BEAT, 0.3) + 0.25;
        lp.type = 'lowpass'; lp.frequency.setValueAtTime(900, t); lp.frequency.exponentialRampToValueAtTime(380, t + 0.3);
        ['triangle', 'sine'].forEach(function (type) {
          var o = ctx.createOscillator();
          o.type = type; o.frequency.value = f;
          o.connect(lp); o.start(t); o.stop(end + 0.05);
        });
        env(g, t, v, 0.008, end);
        lp.connect(g); g.connect(bus);
      },
      // sleigh bells: a burst of high, band-passed noise
      jingle: function (m, t, v) {
        var src = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), hp = ctx.createBiquadFilter(), g = ctx.createGain();
        src.buffer = noise;
        bp.type = 'bandpass'; bp.frequency.value = 8500 + Math.random() * 1500; bp.Q.value = 1.2;
        hp.type = 'highpass'; hp.frequency.value = 5000;
        env(g, t, v, 0.002, t + 0.16);
        src.connect(bp); bp.connect(hp); hp.connect(g); g.connect(bus);
        src.start(t, Math.random() * 0.8); src.stop(t + 0.2);
      }
    };
    function tick() {
      var horizon = ctx.currentTime + 0.6;
      for (;;) {
        var ev = events[ei], t = loopStart + ev.at * BEAT;
        if (t > horizon) break;
        if (t >= ctx.currentTime - 0.05) VOICES[ev.fn](ev.m, t, ev.v, ev.d);
        if (++ei >= events.length) { ei = 0; loopStart += LOOP * BEAT; }
      }
    }
    // Sound is only really on once the browser has let the context run
    function live() { return playing && ctx && ctx.state === 'running'; }

    function play() {
      if (!ctx) build();
      if (!playing) {
        playing = true;
        clearInterval(timer);
        loopStart = ctx.currentTime + 0.15; ei = 0;
        master.gain.cancelScheduledValues(ctx.currentTime);
        master.gain.setValueAtTime(0.0001, ctx.currentTime);
        master.gain.exponentialRampToValueAtTime(0.16, ctx.currentTime + 1.5);
        timer = setInterval(function () { if (ctx.state === 'running') tick(); }, 120);
      }
      var p = ctx.resume();
      if (p && p.then) p.then(render, render);
      render();
    }
    function pause() {
      playing = false;
      render();
      if (!ctx) return;
      master.gain.cancelScheduledValues(ctx.currentTime);
      master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
      master.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.6);
      setTimeout(function () { if (!playing) { clearInterval(timer); ctx.suspend(); } }, 700);
    }
    function remember(on) { try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {} }

    // ---- UI: label + wave on every control ----
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var canvases = controls.map(function (c) { return c.querySelector('.fm-wave'); }).filter(Boolean);
    var level = 0, phase = 0, raf = 0;
    function sizeCanvases() {
      canvases.forEach(function (cv) {
        cv.width = Math.round(cv.clientWidth * dpr);
        cv.height = Math.round(cv.clientHeight * dpr);
      });
    }
    function paint() {
      canvases.forEach(function (cv) {
        var g = cv.getContext('2d'), w = cv.width, h = cv.height, mid = h / 2;
        if (!w || !h) return;
        g.clearRect(0, 0, w, h);
        g.lineCap = 'round';
        g.shadowColor = 'rgba(217,181,108,0.7)';
        g.shadowBlur = 5 * dpr;
        // two layered sine waves, tapered at the ends; amplitude = music level
        [[1, 2.2, 1, 1, 1.4], [0.55, 3.4, -1.3, 0.45, 1]].forEach(function (L) {
          g.globalAlpha = L[3];
          g.strokeStyle = '#d9b56c';
          g.lineWidth = L[4] * dpr;
          g.beginPath();
          for (var x = 0; x <= w; x += 2) {
            var u = x / w, env = Math.sin(Math.PI * u);
            var y = mid + Math.sin(u * L[1] * Math.PI * 2 + phase * L[2]) * mid * 0.8 * level * L[0] * env;
            x ? g.lineTo(x, y) : g.moveTo(x, y);
          }
          g.stroke();
        });
        g.globalAlpha = 1;
      });
    }
    function frame() {
      var target = 0;
      if (live()) {
        analyser.getFloatTimeDomainData(wave);
        var sum = 0;
        for (var i = 0; i < wave.length; i++) sum += wave[i] * wave[i];
        target = Math.max(0.35, Math.min(1, Math.sqrt(sum / wave.length) * 5));
      }
      level += (target - level) * 0.08;
      if (!still) phase += 0.07;
      paint();
      if (live() || level > 0.004) raf = requestAnimationFrame(frame);
      else { level = 0; paint(); raf = 0; }
    }
    function render() {
      var on = live();
      controls.forEach(function (c) {
        c.classList.toggle('playing', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.setAttribute('aria-label', on ? 'Turn festive music off' : 'Turn festive music on');
        var s = c.querySelector('.fm-state');
        if (s) s.textContent = on ? 'On' : 'Off';
      });
      if (!raf) raf = requestAnimationFrame(frame);
    }

    controls.forEach(function (c) {
      c.addEventListener('click', function () {
        if (live()) { pause(); remember(false); } else { play(); remember(true); }
      });
    });

    // Start on the first interaction anywhere (these are the events browsers
    // accept as permission to make sound). Clicks on the controls are left to
    // their own handler above.
    var muted = false;
    try { muted = localStorage.getItem(KEY) === '0'; } catch (e) {}
    var GESTURES = ['pointerdown', 'pointerup', 'touchend', 'mousedown', 'keydown', 'click'];
    function stopListening() { GESTURES.forEach(function (ev) { document.removeEventListener(ev, firstGesture, true); }); }
    function firstGesture(e) {
      if (e.target && e.target.closest && e.target.closest('[data-festive-music]')) { stopListening(); return; }
      if (e.type === 'keydown' && e.key === 'Escape') return;
      play();
      if (live()) stopListening();
    }
    if (AUTOSTART && !muted) GESTURES.forEach(function (ev) { document.addEventListener(ev, firstGesture, true); });

    document.addEventListener('visibilitychange', function () {
      if (!ctx || !playing) return;
      document.hidden ? ctx.suspend() : ctx.resume();
    });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { sizeCanvases(); paint(); }, 150); });
    sizeCanvases();
    paint();
  }

  /* ============ HERO SCROLL FADE ============ */
  function initHeroFade() {
    const hero = document.querySelector('.hero');
    if (!hero) return;
    function onScroll() {
      const y = window.scrollY;
      const vh = window.innerHeight;
      // Fade over the full viewport height — matches the concept exactly
      const progress = Math.min(y / vh, 1);
      hero.style.opacity = 1 - progress;
      hero.style.transform = 'scale(' + (1 - progress * 0.03) + ')';
      // Disable pointer-events once fully faded so content underneath is clickable
      hero.style.pointerEvents = progress >= 1 ? 'none' : 'auto';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ============ NAV REVEAL (homepage only) ============ */
  function initNavReveal() {
    // Only applies on the homepage where the hero is full-screen fixed.
    // The concept puts the announce bar and nav INSIDE .main-content
    // (which has margin-top: 100vh), so they scroll into view naturally
    // as the hero fades. We replicate that by moving the DOM nodes.
    if (!document.body.classList.contains('template-index')) return;
    var announce    = document.querySelector('.announce');
    var nav         = document.querySelector('.nav');
    var mainContent = document.querySelector('.main-content');
    if (!mainContent) return;
    // Move announce + nav into main-content inside ONE sticky wrapper, so once
    // they scroll into view past the hero they pin to the top together:
    // [.nav-stack: announce bar + nav] [hero (fixed)] [trust bar] [sections...]
    var stack = document.createElement('div');
    stack.className = 'nav-stack';
    var peak        = document.querySelector('.peak-notice');
    if (announce) stack.appendChild(announce);
    if (peak)     stack.appendChild(peak);
    if (nav)      stack.appendChild(nav);
    mainContent.insertBefore(stack, mainContent.firstChild);
  }

  /* ============ SEASONAL PEAK NOTICE ============ */
  // Liquid already decided the notice is in its date window, but a cached page
  // can outlive that — so re-check today's UK date here. Then keep the line on
  // ONE line: if the visible copy overflows, step the font down until it fits.
  function initPeakNotice() {
    var el = document.querySelector('.peak-notice');
    if (!el) return;
    var today = 0;
    try {
      today = +new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' })
        .format(new Date()).replace(/-/g, '');
    } catch (e) {}
    var start = +el.dataset.start || 0, end = +el.dataset.end || 99991231;
    if (today && (today < start || today > end)) { el.remove(); return; }
    function fit() {
      el.querySelectorAll('.peak-notice-line').forEach(function (line) {
        line.style.fontSize = '';
        if (!line.offsetParent) return;          // the copy hidden at this width
        var size = parseFloat(getComputedStyle(line).fontSize);
        while (line.scrollWidth > line.clientWidth && size > 8) {
          size -= 0.5;
          line.style.fontSize = size + 'px';
        }
      });
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
  }

  /* ============ MOBILE NAV ============ */
  function initMobileNav() {
    const hamburger = document.getElementById('hamburger');
    const navLinks  = document.getElementById('navLinks');
    if (!hamburger || !navLinks) return;
    hamburger.addEventListener('click', () => {
      navLinks.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      const isOpen = navLinks.classList.contains('open');
      if (spans[0]) spans[0].style.transform = isOpen ? 'rotate(45deg) translate(3px, 4px)' : '';
      if (spans[1]) spans[1].style.opacity   = isOpen ? '0' : '';
      if (spans[2]) spans[2].style.transform = isOpen ? 'rotate(-45deg) translate(3px, -4px)' : '';
    });
    // Dropdown nav-link click handler
    document.querySelectorAll('.nav-link .caret').forEach(c => {
      c.parentElement.addEventListener('click', e => {
        if (getComputedStyle(hamburger).display !== 'none') {
          // Hamburger menu (tablet/phone, see the NAV FIT block in the CSS):
          // toggle the dropdown open/closed
          e.preventDefault();
          e.currentTarget.classList.toggle('open');
        } else {
          // Desktop: clicking the label (not a dropdown item) scrolls to the section
          var clickedEl = e.target;
          var linkEl    = e.currentTarget;
          var onLabel   = clickedEl === linkEl || clickedEl.classList.contains('caret');
          if (onLabel) {
            var anchor = linkEl.dataset.href;
            if (anchor) {
              var target = document.querySelector(anchor);
              if (target) {
                // If a detail pane is open in this section, close it first
                // so the user returns to the section overview, not a sub-pane
                if (target.classList.contains('detail-open')) {
                  target.querySelectorAll('.detail-pane.active').forEach(function (p) { p.classList.remove('active'); });
                  target.classList.remove('detail-open');
                  _openSection = null;
                }
                var y = target.getBoundingClientRect().top + window.scrollY - 80;
                window.scrollTo({ top: y, behavior: 'smooth' });
              } else {
                // Section isn't on this page (e.g. a product page) — go to the
                // homepage and jump to the anchor there
                window.location.href = '/' + anchor;
              }
            }
          }
        }
      });
    });
  }

  /* ============ NAV ACTIVE STATE ============ */
  function initNavActive() {
    const path = window.location.pathname;
    document.querySelectorAll('.nav-link[href]').forEach(a => {
      if (a.getAttribute('href') === path) a.classList.add('active');
    });
  }

  /* ============ CART (Shopify AJAX API) ============ */
  const Cart = {
    async get() {
      const r = await fetch('/cart.js');
      return r.json();
    },
    async add(variantId, qty = 1) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      return r.json();
    },
    async change(key, qty) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      return r.json();
    },
    async update(updates) {
      const r = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      return r.json();
    }
  };

  async function refreshCartBadge() {
    try {
      const cart = await Cart.get();
      document.querySelectorAll('.cart-badge').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
      return cart;
    } catch (e) { /* offline / preview */ }
  }

  /* The /cart page renders its lines server-side (sections/main-cart.liquid), so a
     cart mutation leaves it stale — renderCartDrawer() only repaints the drawer.
     Re-render just that section via the Section Rendering API and swap it in, so
     quantities update in place rather than reloading the whole page.
     The section id is read off the wrapper Shopify emits (shopify-section-…)
     rather than hardcoded — for a JSON template it is 'template--<id>__main',
     not the key in templates/cart.json.
     Returns true when it handled the page (i.e. we are on /cart). */
  async function refreshCartPage() {
    const current = document.getElementById('cart-page');
    if (!current) return false;
    try {
      const wrapper = current.closest('.shopify-section');
      const sectionId = wrapper ? wrapper.id.replace(/^shopify-section-/, '') : 'main-cart';
      const r = await fetch('/cart?section_id=' + encodeURIComponent(sectionId));
      if (!r.ok) throw new Error('section render ' + r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.getElementById('cart-page');
      if (!fresh) throw new Error('no #cart-page in section markup');
      current.replaceWith(fresh);
    } catch (e) {
      // Never leave the customer looking at a stale cart — fall back to a reload.
      window.location.reload();
    }
    return true;
  }

  /* Cart mutations are fire-and-forget from inline onclick handlers, so a fast
     double-click could interleave two change.js calls and render out of order.
     Serialise them. */
  let _cartOp = Promise.resolve();
  function queueCartOp(fn) {
    _cartOp = _cartOp.then(fn, fn);
    return _cartOp;
  }

  async function renderCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    const items  = document.getElementById('cartItems');
    const subEl  = document.getElementById('cartSubtotal');
    if (!drawer || !items) return;
    const clearBtn = document.getElementById('cartClear');
    try {
      const cart = await Cart.get();
      if (!cart.items || cart.items.length === 0) {
        items.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
        if (subEl) subEl.textContent = '£0.00';
        if (clearBtn) clearBtn.style.display = 'none';
        return;
      }
      // Configured kits (lines tagged with a hidden _kit_id property by the
      // wardrobe configurator) are all-or-nothing: they render as one block
      // with a single remove control and no per-line editing. Everything else
      // keeps normal per-line qty/remove controls.
      const kits = {};
      const singles = [];
      cart.items.forEach(item => {
        const kitId = item.properties && item.properties._kit_id;
        if (kitId) {
          if (!kits[kitId]) kits[kitId] = { name: (item.properties._kit || 'Lighting Kit'), items: [] };
          kits[kitId].items.push(item);
        } else {
          singles.push(item);
        }
      });

      const kitHtml = Object.keys(kits).map(kitId => {
        const kit = kits[kitId];
        const kitTotal = kit.items.reduce((sum, i) => sum + i.line_price, 0);
        return `
        <div class="cart-kit" data-kit="${kitId}">
          <div class="cart-kit-head">
            <div class="cart-item-name">${kit.name}</div>
            <div class="cart-item-side">
              <button class="cart-item-remove" aria-label="Remove ${kit.name}" onclick="iLuminaire.cartRemoveKit('${kitId}')">✕</button>
              <div class="cart-item-price">${formatMoney(kitTotal)}</div>
            </div>
          </div>
          ${kit.items.map(i => `
          <div class="cart-kit-line">
            <div class="cart-item-img">
              ${i.image ? `<img class="cart-item-photo" src="${i.image}" alt="${i.title}">` : ''}
            </div>
            <div class="cart-kit-line-name">${i.quantity} × ${i.product_title}</div>
            <div class="cart-kit-line-price">${i.line_price === 0 ? 'Included' : formatMoney(i.line_price)}</div>
          </div>`).join('')}
          <div class="cart-kit-note">Configured kit — sold as a complete set</div>
        </div>`;
      }).join('');

      items.innerHTML = kitHtml + singles.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-img">
            ${item.image ? `<img class="cart-item-photo" src="${item.image}" alt="${item.title}">` : ''}
          </div>
          <div>
            <div class="cart-item-name">${item.product_title}</div>
            <div class="cart-item-spec">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="cart-item-qty">
              <button onclick="iLuminaire.cartChangeQty('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button onclick="iLuminaire.cartChangeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
          <div class="cart-item-side">
            <button class="cart-item-remove" aria-label="Remove ${item.product_title}" onclick="iLuminaire.cartChangeQty('${item.key}', 0)">✕</button>
            <div class="cart-item-price">${formatMoney(item.line_price)}</div>
          </div>
        </div>
      `).join('');
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
      if (clearBtn) clearBtn.style.display = '';
    } catch (e) { /* offline / preview */ }
  }

  async function cartClearAll() {
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      if (await refreshCartPage()) { refreshCartBadge(); return; }
      renderCartDrawer();
      refreshCartBadge();
    } catch (e) { /* offline / preview */ }
  }

  // Remove every line belonging to a configured kit in one action
  async function cartRemoveKit(kitId) {
    try {
      const cart = await Cart.get();
      const updates = {};
      cart.items.forEach(i => {
        if (i.properties && i.properties._kit_id === kitId) updates[i.key] = 0;
      });
      if (Object.keys(updates).length) await Cart.update(updates);
      if (await refreshCartPage()) { refreshCartBadge(); return; }
      renderCartDrawer();
      refreshCartBadge();
    } catch (e) { /* offline / preview */ }
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function openCartDrawer() {
    const drawer  = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (!drawer) return;
    renderCartDrawer();
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer  = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (drawer)  drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function cartChangeQty(key, qty) {
    return queueCartOp(async () => {
      await Cart.change(key, qty > 0 ? qty : 0);
      if (await refreshCartPage()) { refreshCartBadge(); return; }
      renderCartDrawer();
      refreshCartBadge();
    });
  }

  /* Step a line by a delta rather than an absolute quantity. The /cart page bakes
     the target quantity into each button's onclick, so two clicks landing before
     the re-render would both post the same number (+1 twice = +1). Reading the
     live quantity inside the queued op makes each click count. */
  function cartStepQty(key, delta) {
    return queueCartOp(async () => {
      const cart = await Cart.get();
      const line = (cart.items || []).find(i => i.key === key);
      if (!line) return;
      await Cart.change(key, Math.max(0, line.quantity + delta));
      if (await refreshCartPage()) { refreshCartBadge(); return; }
      renderCartDrawer();
      refreshCartBadge();
    });
  }

  async function addToCartBtn(btn, variantId, qty = 1) {
    const orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    try {
      await Cart.add(variantId, qty);
      btn.textContent = '✓ Added';
      btn.style.background = 'var(--accent)';
      btn.style.color = '#03161e';
      btn.style.borderColor = 'var(--accent)';
      refreshCartBadge();
      setTimeout(() => {
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.style.borderColor = '';
        btn.disabled = false;
      }, 1400);
    } catch (e) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  /* "You may also need" quick-add: the + in the tile corner. The tile is a link to the
     product, so swallow the click before it navigates. Single-variant products only —
     the snippet renders an arrow through to the page for anything with options. */
  function initAlsoNeed() {
    document.querySelectorAll('[data-also-add]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const id = parseInt(btn.dataset.alsoAdd, 10);
        if (!id || btn.disabled) return;
        queueCartOp(async () => {
          btn.disabled = true;
          try {
            await Cart.add(id, 1);
            btn.textContent = '✓';
            btn.classList.add('is-added');
            refreshCartBadge();
            renderCartDrawer();
            setTimeout(() => {
              btn.textContent = '+';
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 1400);
          } catch (err) {
            btn.disabled = false;
          }
        });
      });
    });
  }

  function initCartDrawer() {
    document.querySelectorAll('[data-cart-open]').forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
    });
    const overlay = document.getElementById('cartOverlay');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    const closeBtn = document.getElementById('cartClose');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    const clearBtn = document.getElementById('cartClear');
    if (clearBtn) clearBtn.addEventListener('click', cartClearAll);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCartDrawer(); });
    refreshCartBadge();
  }

  /* ============ DETAIL PANE (category card expand/collapse) ============ */
  // Track which section is currently open so closeDetail() never has to re-query
  var _openSection = null;

  function openDetail(cardEl, detailId) {
    const section = cardEl.closest('.section');
    const detail  = document.getElementById('detail-' + detailId);
    if (!section || !detail) return;
    const sr = section.getBoundingClientRect();
    const cr = cardEl.getBoundingClientRect();
    const ox = ((cr.left - sr.left) + cr.width  / 2) / sr.width  * 100;
    const oy = ((cr.top  - sr.top)  + cr.height / 2) / sr.height * 100;
    detail.style.transformOrigin = ox + '% ' + oy + '%';
    section.querySelectorAll('.detail-pane.active').forEach(p => p.classList.remove('active'));
    detail.classList.add('active');
    section.classList.add('detail-open');
    _openSection = section;
    setDetailHash(section.id, detailId);
    requestAnimationFrame(() => {
      const top = section.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  /* Reflect the open detail pane in the URL (without adding history entries) so
     that returning to this page — via Back, refresh or a share link — reopens
     the same pane and lands on its section instead of the top of the page. */
  function setDetailHash(sectionId, detailId) {
    if (!sectionId || !detailId) return;
    try { history.replaceState(null, '', '#' + sectionId + ':' + detailId); } catch (e) {}
  }
  function clearDetailHash(sectionId) {
    try { history.replaceState(null, '', sectionId ? '#' + sectionId : location.pathname); } catch (e) {}
  }

  function closeDetail(btn) {
    // If the button element is passed (via onclick="closeDetail(this)"), walk up
    // directly to find the owning section — no stored state needed.
    var section;
    if (btn && btn.closest) {
      section = btn.closest('.section');
    } else {
      section = _openSection || document.querySelector('.section.detail-open');
    }
    if (!section) return;
    section.querySelectorAll('.detail-pane.active').forEach(function (p) { p.classList.remove('active'); });
    section.classList.remove('detail-open');
    _openSection = null;
    clearDetailHash(section.id);
    // Mobile: #downlights opens as a fixed popup over the page, and the
    // collapsed section has no height — scrolling to it would dump the user
    // at the next section (networking). Stay where they were instead.
    if (section.id === 'downlights' && window.matchMedia('(max-width: 720px)').matches) return;
    requestAnimationFrame(function () {
      var top = section.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDetail(); });

  /* ============ DETAIL PANE — open from nav dropdown or deep-link hash ============ */
  function openDetailFromNav(sectionId, detailId, instant) {
    const section = document.getElementById(sectionId);
    const detail  = document.getElementById('detail-' + detailId);
    if (!section || !detail) return;
    if (detail.classList.contains('active') && section.classList.contains('detail-open')) return;
    section.querySelectorAll('.detail-pane.active').forEach(p => p.classList.remove('active'));
    detail.style.transformOrigin = '50% 0%';
    detail.classList.add('active');
    section.classList.add('detail-open');
    _openSection = section;
    setDetailHash(sectionId, detailId);
    // Same mobile-popup rule as closeDetail: don't move the page under the overlay.
    if (sectionId === 'downlights' && window.matchMedia('(max-width: 720px)').matches) return;
    requestAnimationFrame(() => scrollToTarget(section, instant));
  }

  /* Quick fade-out for click feedback, then navigate. Arriving pages animate in
     via body.is-ready (subpages zoom-fade, the homepage fades) — see the CSS. */
  function navigateWithFade(dest) {
    document.body.classList.remove('is-ready');
    setTimeout(() => { window.location.href = dest; }, 160);
  }

  /* Wire up nav dropdown links that carry data-detail */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#navLinks .dropdown a[data-detail]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const sectionId = a.getAttribute('href').split('#').pop();
        const detailId  = a.dataset.detail;
        if (!document.getElementById(sectionId)) {
          // Not on the homepage — fade out, then arrive with a deep-link
          // hash that handleDetailHash() opens before the fade-in.
          navigateWithFade('/#' + sectionId + ':' + detailId);
          return;
        }
        openDetailFromNav(sectionId, detailId);
        a.closest('.nav-link')?.classList.remove('open');
        document.getElementById('navLinks')?.classList.remove('open');
      });
    });
  });

  /* Handle hashes arriving from other pages.
     Deep-link hashes like /#strip:strip-reels open the matching detail pane;
     plain section hashes like /#smart land on the section itself — both with
     the same sticky-nav offset. When `instant` is true (initial page load)
     everything jumps into position BEFORE the body fade-in, so the arrival
     is seamless. */
  /* `instant` must bypass the CSS `scroll-behavior: smooth` on <html> —
     passing behavior:'auto' does NOT do that (it defers to the CSS), so we
     temporarily disable it for a genuine jump. */
  function scrollToTarget(el, instant) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    if (instant) {
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, top);
      html.style.scrollBehavior = prev;
    } else {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  // Sections that have since become detail panes. Without the alias an old link
  // (#cct-studio) looks up an id that no longer exists and silently does nothing.
  const LEGACY_HASH = { 'cct-studio': 'strip:cct-studio' };

  // Programmatically select one CCT chip in the strip-reels pane (used by the
  // CCT Studio's "Shop This Temperature" when it arrives via a deep-link hash).
  function applyReelCctFilter(val) {
    const bar = document.getElementById('reelFilters');
    if (!bar || !val) return;
    bar.querySelectorAll('.filter-chip.active').forEach(c => c.classList.remove('active'));
    const chip = bar.querySelector('.filter-chips[data-filter="cct"] .filter-chip[data-val="' + val + '"]');
    if (chip) chip.click();
  }

  function handleDetailHash(instant) {
    let h = location.hash.replace('#', '');
    if (!h) return;
    if (LEGACY_HASH[h]) h = LEGACY_HASH[h];
    if (h.includes(':')) {
      // Optional trailing filter hint: strip:strip-reels:cct=Tunable
      const parts = h.split(':');
      const sec = parts[0], det = parts[1];
      let cct = null;
      if (parts[2] && parts[2].indexOf('cct=') === 0) cct = decodeURIComponent(parts[2].slice(4));
      const openAndFilter = (fast) => {
        openDetailFromNav(sec, det, fast);
        if (cct) requestAnimationFrame(() => requestAnimationFrame(() => applyReelCctFilter(cct)));
      };
      if (instant === true) { openAndFilter(true); return; }
      setTimeout(() => openAndFilter(false), 80);
    } else {
      const target = document.getElementById(h);
      if (!target) return;
      if (instant === true) { scrollToTarget(target, true); return; }
      setTimeout(() => scrollToTarget(target), 80);
    }
  }
  window.addEventListener('hashchange', handleDetailHash);

  /* ============ PILLS FILTER ============ */
  function initPills() {
    document.querySelectorAll('.pills').forEach(bar => {
      bar.addEventListener('click', e => {
        const pill = e.target.closest('.pill');
        if (!pill) return;
        bar.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        const filter = pill.dataset.filter;
        const grid   = bar.nextElementSibling;
        if (!grid) return;
        grid.querySelectorAll('[data-category]').forEach(card => {
          card.style.display = (!filter || filter === 'all' || card.dataset.category === filter) ? '' : 'none';
        });
      });
    });
  }

  /* ============ DETAIL-PANE CHIP FILTERS ============ */
  /* Generic Finish / IP / CCT filtering for .filter-bar blocks inside detail panes.
     Chips toggle; multiple chips in one group = OR, across groups = AND. */
  function initChipFilters() {
    document.querySelectorAll('.filter-bar').forEach(bar => {
      const section = bar.closest('.detail-section') || bar.parentElement;
      if (!section) return;
      const grid = section.querySelector('.detail-products');
      if (!grid) return;
      const empty = grid.querySelector('.filter-empty');

      // Persist active chips per filter-bar so that leaving to a product page
      // and hitting Back re-opens the pane with the same filters applied.
      const storeKey = bar.id ? 'iluminaire_filters_' + bar.id : null;
      function save() {
        if (!storeKey) return;
        const state = {};
        bar.querySelectorAll('.filter-chips').forEach(g => {
          const vals = Array.from(g.querySelectorAll('.filter-chip.active')).map(c => c.dataset.val);
          if (vals.length) state[g.dataset.filter] = vals;
        });
        try {
          if (Object.keys(state).length) sessionStorage.setItem(storeKey, JSON.stringify(state));
          else sessionStorage.removeItem(storeKey);
        } catch (e) {}
      }
      function restore() {
        if (!storeKey) return;
        let state;
        try { state = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) { state = null; }
        if (!state) return;
        bar.querySelectorAll('.filter-chips').forEach(g => {
          const vals = state[g.dataset.filter];
          if (!vals) return;
          g.querySelectorAll('.filter-chip').forEach(c => {
            if (vals.indexOf(c.dataset.val) !== -1) c.classList.add('active');
          });
        });
        apply();
      }

      function apply() {
        const groups = {};
        bar.querySelectorAll('.filter-chips').forEach(g => {
          const key = g.dataset.filter;
          const active = Array.from(g.querySelectorAll('.filter-chip.active')).map(c => c.dataset.val);
          if (active.length) groups[key] = active;
        });
        let visible = 0;
        grid.querySelectorAll('.detail-product').forEach(card => {
          // A card's value for a group may be space-separated (e.g. data-strip="White CCT"):
          // the card matches the group if ANY of its values is among the active chips.
          const show = Object.keys(groups).every(k => {
            const cardVals = (card.dataset[k] || '').split(/\s+/).filter(Boolean);
            return groups[k].some(v => cardVals.indexOf(v) !== -1);
          });
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (empty) empty.style.display = visible ? 'none' : '';
      }

      function clearAll() {
        bar.querySelectorAll('.filter-chip.active').forEach(c => c.classList.remove('active'));
        apply();
        save();
      }

      bar.addEventListener('click', e => {
        const chip = e.target.closest('.filter-chip');
        if (chip) { chip.classList.toggle('active'); apply(); save(); return; }
        if (e.target.closest('.filter-clear')) clearAll();
      });
      if (empty) empty.addEventListener('click', e => {
        if (e.target.closest('.filter-clear')) clearAll();
      });

      restore();
    });
  }

  /* ============ TILE SKUs ============ */
  /* Show each product's SKU on its tile, between the blue spec line and the
     price. Handles come from the tile's own href; SKUs from the server-rendered
     window.ILUM_SKUS map (built in the sku-map snippet). Purely additive and
     guarded, so a missing map or handle just leaves the tile as it was. */
  function initTileSkus() {
    var map = window.ILUM_SKUS;
    if (!map) return;
    document.querySelectorAll('a.detail-product[href*="/products/"]').forEach(function (tile) {
      var body = tile.querySelector('.dp-body');
      if (!body || body.querySelector('.dp-sku')) return;
      var m = tile.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
      var sku = m && map[m[1]];
      if (!sku) return;
      var el = document.createElement('div');
      el.className = 'dp-sku';
      el.textContent = sku;
      var price = body.querySelector('.dp-price');
      if (price) body.insertBefore(el, price);
      else body.appendChild(el);
    });
  }

  /* ============ BEST SELLER TAGS ============ */
  /* Curated best-seller list (a merchandising choice, not live sales data).
     Adds a corner badge to matching product tiles, keyed on the tile's href.
     Edit this list to change which tiles are flagged. */
  var BEST_SELLERS = {
    // LED strip — 240 LED/m IP20 whites + High-Output + both RGBW (5)
    'high-output-cri90-led-strip-240-ip20': 1,
    'warm-white-led-strip-240-ip20': 1,
    'natural-white-led-strip-240-ip20': 1,
    'rgbw-led-strip-natural-white-4000k': 1,
    'rgbw-led-strip-warm-white-3000k': 1,
    // Driver — 150W
    'pw-150-24-led-driver': 1,
    // Profiles — the three plaster-in (2 wall wash + linear)
    'plaster-in-wall-wash-ceiling-profile': 1,
    'plaster-in-wall-wash-profile': 1,
    'plaster-in-linear-profile': 1,
    // Controller — WT1
    'wt1-wifi-rf-controller': 1,
    // Accessories — inline Wago, 3-way Wago, 2-core cable
    'wago-221-2411-inline-60-pack': 1,
    'wago-221-413-3-way-50-pack': 1,
    'time-2192y-2-core-cable-50m': 1,
    // Wall switches — T21, T24, TW4-4 (white)
    't21-wall-switch-white': 1,
    't24-wall-switch-white': 1,
    'tw4-4-wall-switch-white': 1,
    // Plaster-in downlights — IP20 white: round single, square single, twin
    'round-trimless-downlight-ip20-white': 1,
    'square-trimless-downlight-ip20-white': 1,
    'rectangle-twin-trimless-downlight-ip20-white': 1,
    // Bulb — GU10 3000K
    'gu10-led-bulb-3000k': 1
  };
  function initBestSellers() {
    document.querySelectorAll('a.detail-product[href*="/products/"]').forEach(function (tile) {
      var m = tile.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
      if (!m || !BEST_SELLERS[m[1]]) return;
      var img = tile.querySelector('.dp-img');
      if (!img || img.querySelector('.dp-bestseller')) return;
      // Its corner belongs to the Out of Stock / Discontinued stamp, which is
      // translucent — a blue pill underneath tints it.
      if (img.classList.contains('is-soldout') || img.classList.contains('is-discontinued')) return;
      var b = document.createElement('span');
      b.className = 'dp-bestseller';
      b.textContent = 'Best Seller';
      img.appendChild(b);
    });
  }

  /* ============ PRODUCT SPEC BADGES ============ */
  /* Build a 2–3 badge headline-spec strip under the price on product pages.
     Reads the already-rendered Specifications table (so values are decoded —
     ·, ×, ≤, ² — and trim uniformly) and shows each product's highest-priority
     available specs. Products with no matching specs get no strip. */
  function initSpecBadges() {
    var mount = document.getElementById('specBadges');
    if (!mount || mount.querySelector('.spec-badges')) return;

    var rows = [];
    document.querySelectorAll('#pane-specs table tr').forEach(function (tr) {
      var td = tr.querySelectorAll('td');
      if (td.length >= 2) rows.push({ label: td[0].textContent.trim().toLowerCase(), value: td[1].textContent.trim(), used: false });
    });
    if (!rows.length) return;

    function headline(v) { return v.split(/[·—@(;]/)[0].trim().slice(0, 18).trim(); }
    function cutParen(v) { return v.split('(')[0].trim(); }
    function warrantyFmt(v) { var m = v.match(/(\d+)\s*[- ]?year/i); return m ? (m[1] + (m[1] === '1' ? ' year' : ' years')) : headline(v); }
    function sdcmFmt(v) { return cutParen(v).replace(/^sdcm\s*/i, '').trim(); }
    function ampsFmt(v) { var m = v.match(/(\d+(?:\.\d+)?)\s*a\b/i); return m ? (m[1] + 'A') : headline(v); }
    function criFmt(v) { var m = v.match(/[≥>]\s*(\d{2,3})/); if (m) return '≥ ' + m[1]; m = v.match(/(\d{2,3})/); return m ? m[1] : ''; }
    function lengthFmt(v) { var m = v.match(/[\d.]+\s*m\b/); return m ? m[0].replace(/\s+/g, '') : headline(v); }
    // Reject values that trimmed down to something meaningless (e.g. "5 ×" from a
    // channel-count "Output power" row) — too short, or left dangling on a separator.
    function valid(s) { return s && s.length >= 2 && !/[×·–—@/]\s*$/.test(s); }

    // [ label-prefix (lowercase), badge label, value formatter ] — highest priority first.
    var PRIORITY = [
      ['warranty', 'Warranty', warrantyFmt],
      ['lifespan', 'Lifetime', cutParen],
      ['colour consistency', 'SDCM', sdcmFmt],
      ['output power', 'Power', headline],
      ['max output', 'Output', headline],
      ['ip rating', 'IP Rating', headline],
      ['efficiency', 'Efficiency', headline],
      ['cri', 'CRI', criFmt],
      ['max strip power', 'Max Strip', headline],
      ['beam angle', 'Beam', headline],
      ['conductor range', 'Conductor', headline],
      ['cross-section', 'Conductor', headline],
      ['rating', 'Rated', ampsFmt],
      ['max input current', 'Max Current', headline],
      ['speaker compatibility', 'Load', headline],
      ['length', 'Length', lengthFmt],
      ['cores', 'Cores', headline],
      ['input voltage', 'Input', headline]
    ];

    var chosen = [], usedLabels = {};
    for (var i = 0; i < PRIORITY.length && chosen.length < 3; i++) {
      var key = PRIORITY[i][0], lab = PRIORITY[i][1], fmt = PRIORITY[i][2];
      if (usedLabels[lab]) continue;
      var row = null;
      for (var j = 0; j < rows.length; j++) {
        if (!rows[j].used && rows[j].label.indexOf(key) === 0) { row = rows[j]; break; }
      }
      if (!row) continue;
      var val = fmt(row.value);
      if (!valid(val)) continue;
      row.used = true; usedLabels[lab] = 1;
      chosen.push({ val: val, lab: lab });
    }
    if (!chosen.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'spec-badges';
    chosen.forEach(function (c) {
      var b = document.createElement('div'); b.className = 'spec-badge';
      var v = document.createElement('span'); v.className = 'sb-val'; v.textContent = c.val;
      var l = document.createElement('span'); l.className = 'sb-lab'; l.textContent = c.lab;
      b.appendChild(v); b.appendChild(l); wrap.appendChild(b);
    });
    mount.appendChild(wrap);
  }

  /* ============ CONFIGURATOR ============ */
  // Wardrobe configurator JS lives in sections/wardrobe-configurator.liquid
  function initConfigurator() {}

  /* ============ CCT SLIDER ============ */
  function initCCT() {
    var CCT_PRESETS = [
      { k: 3000, name: 'Warm White',    tint: '#ffc07e', lite: '#ffe2bc',
        desc: 'Cosy, golden light. Ideal for living rooms, bedrooms, hallways, hospitality and atmospheric cove lighting — the all-rounder warm white most people are after.',
        best: 'Living, bedrooms &amp; hospitality', cri: '80+',  reel: 'Warm White 240 LED/m 5m · £54.99' },
      { k: 4000, name: 'Neutral White', tint: '#fff7e6', lite: '#fffbf2',
        desc: 'A clean, neutral white that renders colour accurately. Best for kitchens, bathrooms, studies and task areas.',
        best: 'Kitchens &amp; task lighting',       cri: '80+',  reel: 'Natural White 240 LED/m 5m · £54.99' },
      { k: 5000, name: 'Daylight',      tint: '#e7eeff', lite: '#eaf0ff',
        desc: 'Bright, sun-like white. Great for utility rooms, garages, workshops and retail where clarity matters more than mood.',
        best: 'Workshops &amp; retail',             cri: '80+',  reel: 'CCT-Tunable 2700–6500K 5m · £64.99' },
      { k: 6000, name: 'Cool White',    tint: '#c4d9ff', lite: '#d6e4ff',
        desc: 'Crisp, clinical light. Use sparingly — perfect for accent washes, retail display and high-CRI showroom work.',
        best: 'Display &amp; clinical',             cri: '80+',  reel: 'CCT-Tunable 2700–6500K 5m · £64.99' }
    ];

    window.updateCCT = function(i) {
      var p = CCT_PRESETS[i];
      if (!p) return;
      var stage = document.getElementById('cctStage');
      var room  = document.getElementById('cctRoom');
      if (stage) stage.style.setProperty('--lite', p.lite);
      if (room)  room.style.setProperty('--lite', p.lite);
      var kEl    = document.getElementById('cctK');    if (kEl)    kEl.textContent    = p.k;
      var nameEl = document.getElementById('cctName'); if (nameEl) nameEl.textContent = p.name;
      var descEl = document.getElementById('cctDesc'); if (descEl) descEl.textContent = p.desc;
      var bestEl = document.getElementById('cctBest'); if (bestEl) bestEl.innerHTML   = p.best;
      var criEl  = document.getElementById('cctCri');  if (criEl)  criEl.textContent  = p.cri;
      var reelEl = document.getElementById('cctReel'); if (reelEl) reelEl.textContent = p.reel;
      var em = document.querySelector('#cctStage .cct-readout .k em');
      if (em) em.style.color = p.tint;
      document.querySelectorAll('#cctTicks .tick').forEach(function(t, idx) {
        t.classList.toggle('active', idx === i);
      });
    };

    var slider = document.getElementById('cctSlider');
    if (!slider) return;
    slider.addEventListener('input', function(e) { window.updateCCT(+e.target.value); });
    window.updateCCT(+slider.value);
  }

  /* ============ BRIGHTNESS SLIDER ============ */
  function initBrightness() {
    const slider = document.getElementById('brightnessSlider');
    const bar    = document.getElementById('cctBar');
    const label  = document.getElementById('brightnessLabel');
    if (!slider) return;
    slider.addEventListener('input', () => {
      const pct = slider.value;
      if (label) label.textContent = pct + '%';
      if (bar) bar.style.opacity = pct / 100;
    });
  }

  /* ============ PRODUCT PAGE ============ */
  /* The product page is owned entirely by sections/main-product.liquid — qty stepper,
     add-to-cart, variant switching, tab rail and thumbnails all live in its inline
     script, because they need the variant JSON it renders.

     What used to be here was a second copy of the qty stepper and a second submit
     handler on #addToCartForm. Both stayed bound, so every Add to Cart fired TWO
     /cart/add.js posts — and this copy's counter tracked [data-qty-delta] buttons the
     markup no longer has, so it always posted quantity 1 on top of the real one.
     The tab rail's old scroll-spy went the same way: it fought the inline version,
     since hidden panes report offsetTop 0. Don't reintroduce any of it here. */

  /* ============ ACCOUNT TABS ============ */
  function initAccount() {
    const rail = document.querySelector('.acc-rail');
    if (!rail) return;
    rail.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        rail.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const target = btn.dataset.target;
        document.querySelectorAll('.acc-pane').forEach(p => {
          p.classList.toggle('active', p.id === target);
        });
      });
    });
  }

  /* ============ LOGIN TABS ============ */
  function initLoginTabs() {
    const tabs = document.querySelector('.login-tabs');
    if (!tabs) return;
    tabs.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        tabs.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        document.querySelectorAll('.login-pane').forEach(p => {
          p.style.display = p.id === btn.dataset.target ? 'block' : 'none';
        });
      });
    });
  }

  /* ============ SMOOTH ANCHOR SCROLL ============ */
  function initSmoothAnchors() {
    // Plain hash links — e.g. href="#strip"
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
    // Homepage-prefixed hash links — e.g. href="/#configurator"
    // On the homepage these should smooth-scroll rather than reload the page
    if (window.location.pathname === '/') {
      document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var id = a.getAttribute('href').slice(2); // strip leading /#
          var target = document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          var y = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
    }
  }

  /* ============ SEARCH ============ */
  // Product index — update hrefs once products are live in Shopify
  var SEARCH_INDEX = [
    // Strip reels
    { nm: 'Warm White LED Strip 5m — 240 LED/m IP20',     cat: 'LED Strip Reels', img: 'warm',    pr: '£54.99', href: '/products/warm-white-led-strip-240-ip20',        keys: 'warm white 3000k 240 led strip reel 24v 2835 ip20 high density 14.4w 1230lm ilum-24-455-20-3000' },
    { nm: 'Natural White LED Strip 5m — 240 LED/m IP20',  cat: 'LED Strip Reels', img: 'neutral', pr: '£54.99', href: '/products/natural-white-led-strip-240-ip20',     keys: 'natural neutral white 4000k 240 led strip reel 24v 2835 ip20 high density 14.4w 1300lm ilum-24-455-20-4000' },
    { nm: 'Warm White IP65 LED Strip 5m — 240 LED/m',     cat: 'LED Strip Reels', img: 'warm',    pr: '£64.99', href: '/products/warm-white-led-strip-240-ip65',        keys: 'warm white 3000k 240 led strip reel 24v 2835 ip65 waterproof bathroom high density ilum-24-455-65-3000' },
    { nm: 'Natural White IP65 LED Strip 5m — 240 LED/m',  cat: 'LED Strip Reels', img: 'neutral', pr: '£64.99', href: '/products/natural-white-led-strip-240-ip65',     keys: 'natural neutral white 4000k 240 led strip reel 24v 2835 ip65 waterproof bathroom high density ilum-24-455-65-4000' },
    { nm: 'Warm White LED Strip 5m — 120 LED/m IP20',     cat: 'LED Strip Reels', img: 'warm',    pr: '£42.99', href: '/products/warm-white-led-strip-120-ip20',        keys: 'warm white 3000k 120 led strip reel 24v 3528 ip20 9.6w 800lm ilum-24-06-20-3000' },
    { nm: 'Natural White LED Strip 5m — 120 LED/m IP20',  cat: 'LED Strip Reels', img: 'neutral', pr: '£42.99', href: '/products/natural-white-led-strip-120-ip20',     keys: 'natural neutral white 4000k 120 led strip reel 24v 3528 ip20 9.6w 800lm ilum-24-06-20-4000' },
    { nm: 'Warm White IP65 LED Strip 5m — 120 LED/m',     cat: 'LED Strip Reels', img: 'warm',    pr: '£42.99', href: '/products/warm-white-led-strip-120-ip65',        keys: 'warm white 3000k 120 led strip reel 24v 3528 ip65 waterproof bathroom ilum-24-06-65-3000' },
    { nm: 'CCT-Tunable LED Strip 5m — 2700K–6500K · 240 LED/m',       cat: 'LED Strip Reels', img: 'cool',    pr: '£64.99', href: '/products/cct-tunable-led-strip-240-ip20',       keys: 'cct tunable white 2700k 6500k adjustable colour temperature led strip reel 24v 2835 240 22w ilum-24-ln28-ip20-cct' },
    { nm: 'High-Output CRI90 LED Strip 5m — 240 LED/m',   cat: 'LED Strip Reels', img: 'cool',    pr: '£84.99', href: '/products/high-output-cri90-led-strip-240-ip20', keys: 'high output cri90 efficiency 130lm 4000k 240 led strip reel 24v 2835 ul 1625lm 12.5w ilum-24-9561-20-4000-ul' },
    { nm: 'RGBW LED Strip 5m — RGB + 3000K White · 120 LED/m',        cat: 'LED Strip Reels', img: 'rgbw',    pr: '£74.99', href: '/products/rgbw-led-strip-warm-white-3000k',      keys: 'rgbw rgb colour color led strip reel 24v 4040 warm white 3000k cri90 120 ilum-24-9689-20-3000' },
    { nm: 'RGBW LED Strip 5m — RGB + 4000K White · 120 LED/m',        cat: 'LED Strip Reels', img: 'rgbw',    pr: '£74.99', href: '/products/rgbw-led-strip-natural-white-4000k',   keys: 'rgbw rgb colour color led strip reel 24v 4040 natural neutral white 4000k cri90 120 ilum-24-9689-20-4000' },
    { nm: 'RGBW LED Strip 5m — RGB + Natural White · 84 LED/m',       cat: 'LED Strip Reels', img: 'rgbw',    pr: '£64.99', href: '/products/rgbw-led-strip-natural-white-84-ip20', keys: 'rgbw rgbnw rgb colour color led strip reel 24v 5050 natural neutral white 4500k 4300k 84 ip20 ilum-24-766-20-rgbw' },
    { nm: 'COB Warm White LED Strip 5m — 480 Chips/m',                cat: 'LED Strip Reels', img: 'warm',    pr: '£44.99', href: '/products/cob-warm-white-led-strip-480-ip20',    keys: 'cob chip on board dotless continuous warm white 3000k 480 chips led strip reel 24v ip20 cri90 ilum-24-9422-20-3000' },
    { nm: 'LED Light Sheet 610 × 305 mm — 4000K · 288 LED/sheet',         cat: 'LED Strip Reels', img: 'cool',    pr: '£69.99', href: '/products/led-light-sheet-4000k',                keys: 'led light sheet panel backlight sign signage mirror splashback 4000k cri90 fh12 cuttable 288 30w 2730lm ilum-24-fh12-sheet' },
    // Profiles
    { nm: 'Flat Surface Profile',          cat: 'Aluminium Profiles',     img: 'profile',    pr: '£11.99',  href: '/products/flat-surface-profile',        keys: 'flat surface mount aluminium profile alp002 drop ceiling boxed kitchen cabinet 17.1 8mm diffuser end caps 120 ilum-004-f' },
    { nm: 'Recessed Profile',              cat: 'Aluminium Profiles',     img: 'profile',    pr: '£13.99',  href: '/products/recessed-profile',            keys: 'recessed aluminium profile alp001 kitchen worktop wardrobe wide lip 23.2 8mm diffuser end caps 240 high density ilum-003-r' },
    { nm: 'Corner Profile',                cat: 'Aluminium Profiles',     img: 'profile',    pr: '£13.99',  href: '/products/corner-profile',              keys: 'corner 45 degree aluminium profile alp006 under kitchen bathroom cabinet 16 16mm clips diffuser end caps 240 ilum-005-c' },
    { nm: 'Plaster-In Linear Profile',     cat: 'Aluminium Profiles',     img: 'profile',    pr: '£15.99',  href: '/products/plaster-in-linear-profile',   keys: 'plaster in linear trimless aluminium profile alp071 wall ceiling plasterboard drywall 61.5 14mm 240 high density ilum-001-pip' },
    { nm: 'Waterproof Recessed Profile',   cat: 'Aluminium Profiles',     img: 'profile',    pr: '£18.99',  href: '/products/waterproof-recessed-profile', keys: 'waterproof recessed ip65 aluminium profile alp033 outdoor tile bathroom niche floor 28.6 11mm sealed diffuser 240 ilum-002-r' },
    { nm: 'Plaster-In Wall Wash Profile',  cat: 'Aluminium Profiles',     img: 'profile',    pr: '£39.99',  href: '/products/plaster-in-wall-wash-profile', keys: 'plaster in wall wash aluminium profile alp082 stairs ceiling skylight 96 18.5mm curved reflector trimless 120 ilum-006-pip' },
    { nm: 'False Ceiling Profile',         cat: 'Aluminium Profiles',     img: 'profile',    pr: '£34.99',  href: '/products/false-ceiling-profile',       keys: 'false ceiling perimeter cove aluminium profile alp118 dropped ceiling shadow gap 45.7 50.1mm 120 ilum-007-e' },
    { nm: 'Plaster-In Wall Wash — Ceiling', cat: 'Aluminium Profiles',    img: 'profile',    pr: '£34.99',  href: '/products/plaster-in-wall-wash-ceiling-profile', keys: 'plaster in wall wash ceiling aluminium profile alp126 94.4 34mm 20mm strip 18w trimless 120 ilum-008-ww' },
    // Drivers
    { nm: 'PW-60-24 60W LED Driver',       cat: 'LED Drivers',            img: 'driver',     pr: '£24.99',  href: '/products/pw-60-24-led-driver',      keys: 'driver power supply 24v 60w psu constant voltage actec pw ip67 waterproof act-pw-60-24' },
    { nm: 'PW-100-24 100W LED Driver',     cat: 'LED Drivers',            img: 'driver',     pr: '£29.99',  href: '/products/pw-100-24-led-driver',     keys: 'driver power supply 24v 100w psu constant voltage actec pw ip67 waterproof act-pw-100-24' },
    { nm: 'PW-150-24 150W LED Driver',     cat: 'LED Drivers',            img: 'driver',     pr: '£39.99',  href: '/products/pw-150-24-led-driver',     keys: 'driver power supply 24v 150w psu constant voltage actec pw ip67 waterproof act-pw-150-24' },
    { nm: 'AW-240-24 240W LED Driver',     cat: 'LED Drivers',            img: 'driver',     pr: '£69.99',  href: '/products/aw-240-24-led-driver',     keys: 'driver power supply 24v 240w psu constant voltage actec aw ip67 metal aluminium waterproof act-aw-240-24' },
    { nm: 'AW-320-24 320W LED Driver',     cat: 'LED Drivers',            img: 'driver',     pr: '£89.99',  href: '/products/aw-320-24-led-driver',     keys: 'driver power supply 24v 320w psu constant voltage actec aw ip67 metal aluminium waterproof act-aw-320-24' },
    // Controllers
    { nm: 'WT1 WiFi & RF Controller',      cat: 'WiFi & RF Controllers',  img: 'controller', pr: '£24.99',  href: '/products/wt1-wifi-rf-controller',  keys: 'wt1 wifi rf controller tuya 2 channel dimming cct white smart alexa google push dim ilum-wt1' },
    { nm: 'WT5 5-in-1 WiFi & RF Controller', cat: 'WiFi & RF Controllers', img: 'controller', pr: '£29.99', href: '/products/wt5-wifi-rf-controller',  keys: 'wt5 wifi rf controller tuya 5 channel rgbw rgb cct colour smart alexa google music ilum-wt5' },
    { nm: 'EV1-X Power Repeater',          cat: 'WiFi & RF Controllers',  img: 'controller', pr: '£26.99',  href: '/products/ev1-x-power-repeater',    keys: 'ev1 ev1-x power repeater amplifier 1 channel 30a single colour pwm long run ilum-ev1x' },
    { nm: 'EV2 Power Repeater',            cat: 'WiFi & RF Controllers',  img: 'controller', pr: '£24.99',  href: '/products/ev2-power-repeater',      keys: 'ev2 power repeater amplifier 2 channel 8a cct tunable white pwm long run ilum-ev2' },
    { nm: 'EV4 Power Repeater',            cat: 'WiFi & RF Controllers',  img: 'controller', pr: '£26.99',  href: '/products/ev4-power-repeater',      keys: 'ev4 power repeater amplifier 4 channel 5a rgbw pwm long run ilum-ev4' },
    // Smart Home
    { nm: 'Paradigm C65-R Ceiling Speakers (6 Pack)', cat: 'Smart Home · Audio', img: 'speaker', pr: '£649.00', href: '/products/paradigm-c65r-ceiling-speakers-6-pack', keys: 'paradigm c65r ceiling speaker 6 pack audio in ceiling par-c65-r-6pack' },
    { nm: 'Lithe Audio Fire Hood 270',     cat: 'Smart Home · Audio',     img: 'speaker',    pr: '£44.00',  href: '/products/lithe-audio-fire-hood-270', keys: 'lithe audio fire hood 270 ceiling speaker acoustic cover lit-firehood270' },
    { nm: 'Arylic H50 Streaming Amplifier', cat: 'Smart Home · Audio',    img: 'amp',        pr: '£239.99', href: '/products/arylic-h50-streaming-amplifier', keys: 'arylic h50 streaming amplifier wifi bluetooth airplay multiroom hdmi ary-h50-24v' },
    { nm: 'Arylic LA50 Streaming Amplifier', cat: 'Smart Home · Audio',   img: 'amp',        pr: '£299.99', href: '/products/arylic-la50-streaming-amplifier', keys: 'arylic la50 streaming amplifier wifi bluetooth airplay multiroom phono ary-la50' },
    { nm: 'Shelly 1 Mini Gen4',            cat: 'Smart Home · Switches',  img: 'switch',     pr: '£19.99',  live: true, href: '/products/shelly-1-mini-gen4',      keys: 'shelly 1 mini gen4 smart relay 1 channel 8a dry contact matter zigbee wifi module she-1mini-g4' },
    { nm: 'Shelly 1PM Gen4',               cat: 'Smart Home · Switches',  img: 'switch',     pr: '£21.99',  live: true, href: '/products/shelly-1pm-gen4',         keys: 'shelly 1pm gen4 smart relay 1 channel 16a power monitoring energy matter zigbee wifi module she-1pm-g4' },
    { nm: 'Shelly 2PM Gen4',               cat: 'Smart Home · Switches',  img: 'switch',     pr: '£29.99',  live: true, href: '/products/shelly-2pm-gen4',         keys: 'shelly 2pm gen4 smart relay 2 channel power monitoring blinds shutters roller matter zigbee wifi module she-2pm-g4' },
    { nm: 'Shelly Dimmer Gen4',            cat: 'Smart Home · Switches',  img: 'switch',     pr: '£38.99',  live: true, href: '/products/shelly-dimmer-gen4',      keys: 'smart dimmer shelly switch 240v wifi gen4 module no neutral trailing edge retractive matter she-dim-g4' },
    { nm: 'Shelly Wall Display XL',        cat: 'Smart Home · Switches',  img: 'switch',     pr: '£357.99', live: true, href: '/products/shelly-wall-display-xl',  keys: 'shelly wall display xl smart home touchscreen control panel controller 10.1 inch she-wdxl-gy' },
    { nm: 'Shelly Plus Plug UK',           cat: 'Smart Home · Switches',  img: 'switch',     pr: '£23.99',  live: true, href: '/products/shelly-plus-plug-uk',     keys: 'shelly plus plug uk smart plug socket 13a power monitoring energy wifi she-plug-uk' },
    { nm: 'Shelly Camera',                 cat: 'Smart Home · Switches',  img: 'switch',     pr: '£38.99',  live: true, href: '/products/shelly-camera',           keys: 'shelly camera black white cctv security indoor 1080p full hd night vision motion detection two way audio wifi home assistant rtsp she-cam-bk she-cam-wh' },
    { nm: 'Shelly Duo Bulb E27 Gen3',      cat: 'Smart Home · Switches',  img: 'switch',     pr: '£10.99',   live: true, href: '/products/shelly-duo-bulb-e27',     keys: 'shelly duo bulb e27 gen3 smart lamp cct tunable white 2700k 6500k dimmable 8.5w 800lm wifi she-duo-e27' },
    // disc: discontinued by the manufacturer — stays findable (the page is indexed and
    // linked from the downlights) but must not show a price it can't be bought at.
    { nm: 'Shelly Duo GU10',               cat: 'Smart Home · Switches',  img: 'switch',     pr: '£14.99',  disc: true, live: true, href: '/products/shelly-duo-gu10',         keys: 'shelly duo gu10 smart bulb lamp spot cct tunable dual white 2700k 6500k dimmable 5w 400lm wifi downlight she-duo-gu10' },
    // Downlights
    { nm: 'Round Trimless Downlight IP20 — White', cat: 'Plaster-In Downlights',  img: 'round',      pr: '£14.99',  href: '/products/round-trimless-downlight-ip20-white', keys: 'round single plaster in trimless downlight ip20 gu10 white fire rated ilum-ts8258-w' },
    { nm: 'Round Trimless Downlight IP20 — Black', cat: 'Plaster-In Downlights',  img: 'round',      pr: '£14.99',  href: '/products/round-trimless-downlight-ip20-black', keys: 'round single plaster in trimless downlight ip20 gu10 black fire rated ilum-ts8258-b' },
    { nm: 'Square Trimless Downlight IP20 — White', cat: 'Plaster-In Downlights', img: 'square',     pr: '£14.99',  href: '/products/square-trimless-downlight-ip20-white', keys: 'square single plaster in trimless downlight ip20 gu10 white fire rated ilum-ts8256-w' },
    { nm: 'Square Trimless Downlight IP20 — Black', cat: 'Plaster-In Downlights', img: 'square',     pr: '£14.99',  href: '/products/square-trimless-downlight-ip20-black', keys: 'square single plaster in trimless downlight ip20 gu10 black fire rated ilum-ts8256-b' },
    { nm: 'Round Trimless Downlight IP65 — White', cat: 'Plaster-In Downlights',  img: 'round',      pr: '£16.99',  href: '/products/round-trimless-downlight-ip65-white', keys: 'round single plaster in trimless downlight ip65 bathroom gu10 white fire rated ilum-ts8365-w' },
    { nm: 'Round Trimless Downlight IP65 — Black', cat: 'Plaster-In Downlights',  img: 'round',      pr: '£16.99',  href: '/products/round-trimless-downlight-ip65-black', keys: 'round single plaster in trimless downlight ip65 bathroom gu10 black fire rated ilum-ts8365-b' },
    { nm: 'Square Trimless Downlight IP65 — White', cat: 'Plaster-In Downlights', img: 'square',     pr: '£16.99',  href: '/products/square-trimless-downlight-ip65-white', keys: 'square single plaster in trimless downlight ip65 bathroom gu10 white fire rated ilum-ts8090-w' },
    { nm: 'Square Trimless Downlight IP65 — Black', cat: 'Plaster-In Downlights', img: 'square',     pr: '£16.99',  href: '/products/square-trimless-downlight-ip65-black', keys: 'square single plaster in trimless downlight ip65 bathroom gu10 black fire rated ilum-ts8090-b' },
    { nm: 'Rectangle Twin Trimless Downlight — White', cat: 'Plaster-In Downlights', img: 'square',  pr: '£25.99',  href: '/products/rectangle-twin-trimless-downlight-ip20-white', keys: 'rectangle twin double plaster in trimless downlight gu10 white fire rated ilum-ts8092-w' },
    { nm: 'Rectangle Twin Trimless Downlight — Black', cat: 'Plaster-In Downlights', img: 'square',  pr: '£25.99',  href: '/products/rectangle-twin-trimless-downlight-ip20-black', keys: 'rectangle twin double plaster in trimless downlight gu10 black fire rated ilum-ts8092-b' },
    { nm: 'T67 IC Insulation Bracket',     cat: 'Plaster-In Downlights',  img: 'round',      pr: '£0.99',   href: '/products/t67-ic-bracket',          keys: 't67 ic insulation bracket downlight ip20 fire ilum-t67' },
    { nm: 'T68 IC Insulation Bracket',     cat: 'Plaster-In Downlights',  img: 'round',      pr: '£0.99',   href: '/products/t68-ic-bracket',          keys: 't68 ic insulation bracket downlight ip65 twin fire ilum-t68' },
    { nm: 'GU10 LED Bulb — 3000K',         cat: 'Plaster-In Downlights',  img: 'round',      pr: '£1.99',   href: '/products/gu10-led-bulb-3000k',     keys: 'gu10 led bulb lamp warm white 3000k 7w ilum-gu10-7n38-3000k' },
    { nm: 'GU10 LED Bulb — 4000K',         cat: 'Plaster-In Downlights',  img: 'round',      pr: '£1.99',   href: '/products/gu10-led-bulb-4000k',     keys: 'gu10 led bulb lamp neutral natural white 4000k 7w ilum-gu10-7n38-4000k' },
    // Wall Switches
    { nm: 'TW1-4 Dimming Dial — White',    cat: 'Wall Switches',          img: 'switch',     pr: '£29.99',  href: '/products/tw1-4-wall-switch-white',  keys: 'wall switch touch panel dimming dial white tw1 ilum-tw1-4-wh' },
    { nm: 'TW1-4 Dimming Dial — Black',    cat: 'Wall Switches',          img: 'switch',     pr: '£31.99',  href: '/products/tw1-4-wall-switch-black',  keys: 'wall switch touch panel dimming dial black tw1 ilum-tw1-4-bk' },
    { nm: 'TW2-4 CCT Dial — White',        cat: 'Wall Switches',          img: 'switch',     pr: '£39.99',  href: '/products/tw2-4-wall-switch-white',  keys: 'wall switch touch panel cct colour temperature dial white tw2 ilum-tw2-4-wh' },
    { nm: 'TW4-4 RGBW Dial — White',       cat: 'Wall Switches',          img: 'switch',     pr: '£34.99',  href: '/products/tw4-4-wall-switch-white',  keys: 'wall switch touch panel rgbw rgb colour wheel dial white tw4 ilum-tw4-4-wh' },
    { nm: 'TW4-4 RGBW Dial — Black',       cat: 'Wall Switches',          img: 'switch',     pr: '£37.99',  href: '/products/tw4-4-wall-switch-black',  keys: 'wall switch touch panel rgbw rgb colour wheel dial black tw4 ilum-tw4-4-bk' },
    { nm: 'T21 Dimming Slide — White',     cat: 'Wall Switches',          img: 'switch',     pr: '£34.99',  href: '/products/t21-wall-switch-white',    keys: 'wall switch touch panel dimming slide linear white t21 ilum-t21-wh' },
    { nm: 'T21 Dimming Slide — Black',     cat: 'Wall Switches',          img: 'switch',     pr: '£36.99',  href: '/products/t21-wall-switch-black',    keys: 'wall switch touch panel dimming slide linear black t21 ilum-t21-bk' },
    { nm: 'T24 RGBW Slide — White',        cat: 'Wall Switches',          img: 'switch',     pr: '£39.99',  href: '/products/t24-wall-switch-white',    keys: 'wall switch touch panel rgbw rgb colour slide linear white t24 ilum-t24-wh' },
    { nm: 'T24 RGBW Slide — Black',        cat: 'Wall Switches',          img: 'switch',     pr: '£42.99',  href: '/products/t24-wall-switch-black',    keys: 'wall switch touch panel rgbw rgb colour slide linear black t24 ilum-t24-bk' },
    // Accessories
    { nm: 'Wago 221-412 (2-Way · 100 Pack)', cat: 'Accessories',          img: 'profile',    pr: '£34.99',  href: '/products/wago-221-412-2-way-100-pack',  keys: 'wago 221 412 2 way connector lever splice 100 pack wago-221-412-100pk' },
    { nm: 'Wago 221-413 (3-Way · 50 Pack)',  cat: 'Accessories',          img: 'profile',    pr: '£18.99',  href: '/products/wago-221-413-3-way-50-pack',   keys: 'wago 221 413 3 way connector lever splice 50 pack wago-221-413-50pk' },
    { nm: 'Wago 221-2411 (Inline · 60 Pack)', cat: 'Accessories',         img: 'profile',    pr: '£25.49',  href: '/products/wago-221-2411-inline-60-pack', keys: 'wago 221 2411 inline connector lever splice 60 pack wago-221-2411-60pk' },
    { nm: 'Hippo PCB Connector — 240 LED/m', cat: 'Accessories',          img: 'profile',    pr: '£1.29',   href: '/products/hippo-pcb-connector-240-led',  keys: 'hippo pcb connector 240 led strip solderless 10mm hip-10mm-240' },
    { nm: 'Hippo PCB Connector — 120 LED/m', cat: 'Accessories',          img: 'profile',    pr: '£1.29',   href: '/products/hippo-pcb-connector-120-led',  keys: 'hippo pcb connector 120 led strip solderless 10mm hip-10mm-120' },
    { nm: 'Strip-to-Wire Connector 8mm',   cat: 'Accessories',            img: 'profile',    pr: '£0.99',   href: '/products/strip-to-wire-connector-8mm',  keys: 'strip wire solderless connector 8mm quick 15cm lead stw-8mm-15cm' },
    { nm: 'Strip-to-Wire Connector 10mm',  cat: 'Accessories',            img: 'profile',    pr: '£0.99',   href: '/products/strip-to-wire-connector-10mm', keys: 'strip wire solderless connector 10mm quick 15cm lead stw-10mm-15cm' },
    { nm: '10mm L-Shape Corner Connector', cat: 'Accessories',            img: 'profile',    pr: '£1.29',   href: '/products/l-shape-corner-connector-10mm', keys: 'l shape corner connector 10mm 90 degree right angle strip joint solderless pcb lsc-10mm-90' },
    { nm: 'Time 2192Y 2-Core Cable (50m)', cat: 'Accessories',            img: 'profile',    pr: '£18.99',  href: '/products/time-2192y-2-core-cable-50m',  keys: 'dc cable 2 core wire led run flex 2192y 50m drum white strip time-2192y-50m' },
    { nm: 'Time 2183Y 3-Core Cable (50m)', cat: 'Accessories',            img: 'profile',    pr: '£46.99',  href: '/products/time-2183y-3-core-cable-50m',  keys: 'cct cable 3 core wire flex 2183y 50m drum tunable white strip time-2183y-50m' },
    { nm: 'Time 3095Y 5-Core Cable (10m)', cat: 'Accessories',            img: 'profile',    pr: '£11.49',  href: '/products/time-3095y-5-core-cable-10m',  keys: 'rgbw cable 5 core wire flex 3095y 10m coil strip time-3095y-10m' }
  ];

  /* ============ LIVE PRICES (data-live tiles) ============ */
  /* Tiles marked data-live, and their SEARCH_INDEX entries, take price and the
     'Discontinued' tag from Shopify's public /products.json, so a price or status
     change made in the admin (by hand, or by the books app's Shelly check) shows
     without a theme push. The hardcoded markup is the fallback and what crawlers see.
     One request per 10 minutes per tab, cached in sessionStorage. */
  var LIVE_KEY = 'ilum_live_products_v1';
  function applyLiveProducts(map) {
    function money(p) { return '£' + Number(p).toFixed(2); }
    document.querySelectorAll('a.detail-product[data-live]').forEach(function (tile) {
      var m = tile.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
      var info = m && map[m[1]];
      if (!info) return;
      var price = tile.querySelector('.dp-price');
      if (price) price.textContent = money(info.price);
      var img = tile.querySelector('.dp-img');
      var arrow = tile.querySelector('.dp-arrow span');
      var stamp = img && img.querySelector('.disc-stamp');
      tile.classList.toggle('is-discontinued', info.disc);
      if (img) img.classList.toggle('is-discontinued', info.disc);
      if (info.disc && img && !stamp) {
        stamp = document.createElement('span');
        stamp.className = 'disc-stamp';
        stamp.textContent = 'Discontinued';
        img.appendChild(stamp);
        var bs = img.querySelector('.dp-bestseller');
        if (bs) bs.remove();
      } else if (!info.disc && stamp) {
        stamp.remove();
      }
      if (arrow) arrow.textContent = info.disc ? 'No longer available' : 'View Product';
    });
    SEARCH_INDEX.forEach(function (e) {
      var m = e.href.match(/\/products\/([a-z0-9-]+)/);
      var info = m && map[m[1]];
      if (!info || !e.live) return;
      e.pr = money(info.price);
      e.disc = info.disc;
    });
  }
  function initLiveProducts() {
    if (!document.querySelector('a.detail-product[data-live]') && !document.getElementById('searchModal')) return;
    try {
      var c = JSON.parse(sessionStorage.getItem(LIVE_KEY) || 'null');
      if (c && Date.now() - c.t < 600000) { applyLiveProducts(c.map); return; }
    } catch (e) {}
    fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) return;
        var map = {};
        d.products.forEach(function (p) {
          var prices = p.variants.map(function (v) { return parseFloat(v.price); });
          map[p.handle] = { price: Math.min.apply(null, prices),
                            disc: (p.tags || []).indexOf('Discontinued') !== -1 };
        });
        try { sessionStorage.setItem(LIVE_KEY, JSON.stringify({ t: Date.now(), map: map })); } catch (e) {}
        applyLiveProducts(map);
      })
      .catch(function () {});
  }

  function initSearch() {
    var modal    = document.getElementById('searchModal');
    var input    = document.getElementById('searchInput');
    var closeBtn = document.getElementById('searchClose');
    var toggle   = document.getElementById('searchToggle');
    var results  = document.getElementById('searchResults');
    var suggest  = document.getElementById('searchSuggest');
    if (!modal) return;

    function openSearch() {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Close cart drawer if open
      if (typeof closeCartDrawer === 'function') closeCartDrawer();
      setTimeout(function () { if (input) input.focus(); }, 50);
    }

    function closeSearch() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (input) input.value = '';
      runSearch('');
    }

    function runSearch(q) {
      q = (q || '').toLowerCase().trim();
      if (!q) {
        if (results) results.innerHTML = '';
        if (suggest) suggest.style.display = '';
        return;
      }
      if (suggest) suggest.style.display = 'none';
      // Match every word of the query independently, not the query as one literal
      // string. Matching the whole string meant "black downlight" and "24v driver"
      // returned nothing at all, because the words are never adjacent in that order
      // in a product's name or keys. Each word must appear somewhere (AND), so extra
      // words still narrow the results rather than widening them.
      var words = q.split(/\s+/).filter(Boolean);
      var matches = SEARCH_INDEX.filter(function (p) {
        var hay = (p.nm + ' ' + p.cat + ' ' + p.keys).toLowerCase();
        return words.every(function (w) { return hay.indexOf(w) !== -1; });
      });
      // Cap the rendered list, but report the true match count — a broad query like
      // "strip" or "white" matches far more than fits, and labelling that "24 Results"
      // would tell the customer the rest don't exist.
      var LIMIT = 24;
      var hits  = matches.slice(0, LIMIT);
      if (!results) return;
      if (hits.length === 0) {
        results.innerHTML = '<div class="search-empty">No results for “' + q + '” &mdash; try “strip”, “downlight”, “speaker” or “wago”.</div>';
        return;
      }
      results.innerHTML =
        '<div class="search-section-label">' + matches.length + ' Result' + (matches.length === 1 ? '' : 's') +
          (matches.length > hits.length ? ' &middot; showing first ' + hits.length : '') + '</div>' +
        '<div class="search-results">' +
        hits.map(function (h) {
          // Real product photo (same dp-* tile image) keyed by handle; fall back to
          // the gradient placeholder if this product has no mapped image.
          var handle = (h.href.split('/products/')[1] || '').split('?')[0];
          var photo  = (window.SEARCH_IMG && window.SEARCH_IMG[handle]) || '';
          var imgHtml = photo
            ? '<div class="sr-img sr-photo"><img src="' + photo + '" alt="" loading="lazy"></div>'
            : '<div class="sr-img product-img ' + h.img + '"></div>';
          return '<a class="search-result" href="' + h.href + '">' +
            imgHtml +
            '<div><div class="sr-cat">' + h.cat + '</div><div class="sr-nm">' + h.nm + '</div></div>' +
            '<div class="sr-pr' + (h.disc ? ' sr-disc' : '') + '">' + (h.disc ? 'Discontinued' : h.pr) + '</div>' +
            '</a>';
        }).join('') +
        '</div>';
    }

    // Wire up toggle button and close button
    if (toggle) toggle.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    // Close on clicking the backdrop (outside the inner panels)
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeSearch();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeSearch();
    });

    // Live search on input
    if (input) {
      input.addEventListener('input', function (e) { runSearch(e.target.value); });
    }

    // Close suggestion links without navigating away on hash links
    var suggLinks = modal.querySelectorAll('.search-suggestions a');
    suggLinks.forEach(function (a) {
      a.addEventListener('click', closeSearch);
    });

    // Expose for external use (e.g. mobile nav)
    window.openSearch  = openSearch;
    window.closeSearch = closeSearch;
  }

/* ============ EXPOSE GLOBALS ============ */
  window.iLuminaire = {
    openDetail,
    closeDetail,
    openDetailFromNav,
    openCartDrawer,
    closeCartDrawer,
    cartChangeQty,
    cartStepQty,
    cartClearAll,
    cartRemoveKit,
    addToCartBtn
  };
  // Also expose closeDetail directly on window so onclick="closeDetail()" always works
  window.closeDetail = closeDetail;

  /* ============ PAGE TRANSITIONS ============ */
  function initPageTransitions() {
    const h = location.hash.replace('#', '');
    const targetId = h ? (h.includes(':') ? h.split(':')[0] : h) : null;
    const hashTarget = targetId ? document.getElementById(targetId) : null;

    const reveal = () => requestAnimationFrame(() => document.body.classList.add('is-ready'));

    if (!hashTarget) {
      // Normal arrival — fade in once the DOM is ready
      reveal();
    } else {
      // Deep-link arrival (/#smart, /#smart:speakers, …): images loading after
      // DOMContentLoaded shift the layout by thousands of pixels, so pinning
      // now and fading in would show the page visibly scrolling. Stay hidden
      // until assets have loaded (capped), pin the section, THEN fade in.
      let revealed = false;
      let userInteracted = false;
      ['wheel', 'touchstart', 'keydown'].forEach(ev =>
        window.addEventListener(ev, () => { userInteracted = true; }, { once: true, passive: true }));
      const settle = () => {
        const el = document.getElementById(targetId);
        if (!revealed) {
          revealed = true;
          if (el) scrollToTarget(el, true);
          reveal();
        } else if (el && !userInteracted) {
          // Load finished after the capped reveal — correct the position
          // instantly unless the user has started scrolling.
          scrollToTarget(el, true);
        }
      };
      window.addEventListener('load', settle);
      setTimeout(settle, 1800); // cap the black screen if assets are slow
    }

    // Re-fade-in on back/forward cache restore
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) document.body.classList.add('is-ready');
    });

    // Quick fade-out before navigating away (arriving page animates in via CSS).
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Skip: same-page anchor links, external, mailto, tel, new-tab links.
      // Hash links to a DIFFERENT page (e.g. /#smart:speakers from a product
      // page) DO get the fade transition.
      if (
        href.startsWith('#') ||
        (link.hash && link.pathname === window.location.pathname) ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('//') ||
        link.target === '_blank' ||
        (href.startsWith('http') && !href.includes(window.location.hostname))
      ) return;

      // Skip modifier keys (cmd+click to open in new tab etc.)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      e.preventDefault();
      const dest = link.href;
      document.body.classList.remove('is-ready');
      setTimeout(() => { window.location.href = dest; }, 160);
    });
  }

  /* ============ INIT ============ */
  document.addEventListener('DOMContentLoaded', () => {
    initPageTransitions();
    // Open any deep-linked detail pane BEFORE the fade-in so arriving
    // from another page reveals the pane already in place.
    handleDetailHash(true);
    initRays();
    initFestive();
    initHeroFade();
    initNavReveal();
    initPeakNotice();
    initSearch();
    initLiveProducts();
    initMobileNav();
    initNavActive();
    initCartDrawer();
    initAlsoNeed();
    initPills();
    initChipFilters();
    initTileSkus();
    initBestSellers();
    initSpecBadges();
    initConfigurator();
    initCCT();
    initBrightness();
    initAccount();
    initLoginTabs();
    initSmoothAnchors();
  });

})();
